import { HttpErrorResponse } from '@angular/common/http';
import { Component } from '@angular/core';
import { CANJE } from 'src/app/shared/constantes/constants';
import { CanjeEnfermera } from 'src/app/models/canje-enfermera';
import { AdministradorService } from 'src/app/services/administrador.service';
import { Paginar } from 'src/app/models/http-paginacion.interface';

@Component({
  selector: 'app-administrador-notificaciones-canje-enfermeras',
  templateUrl: './administrador-notificaciones-canje-enfermeras.component.html',
  styleUrls: ['./administrador-notificaciones-canje-enfermeras.component.scss']
})
export class AdministradorNotificacionesCanjeEnfermerasComponent {
  canjeEnfermera: CanjeEnfermera[] = []
  statusCanje: string[] = [...CANJE];
  currentPage: Paginar = { page: 0, first: 0, rows: 10, pageCount: 0 };
  totalItems: number = 10;

  constructor(private administradorService: AdministradorService) {
    this.getCanjesEnfermeras();
  }

  get totalPaginas(): number {
    return Math.ceil(this.canjeEnfermera.length / this.currentPage.rows);
  }
  get paginacionCanjesEnfermeras(): CanjeEnfermera[] {
    const startIndex = (this.currentPage.page) * this.currentPage.rows;
    return this.canjeEnfermera.slice(startIndex, startIndex + this.currentPage.rows);
  }
  getCanjesEnfermeras(): void {
    this.administradorService.notificacionesCanjesEnfermeras()
      .subscribe({
        next: (resp) => {
          this.canjeEnfermera = resp.datos
          this.totalItems = resp.datos.length;
        },
        error: (err: HttpErrorResponse) => { console.log(err.error.message) },
        complete: () => { }
      })
  }

  getCanje(id: number): string {
    return this.statusCanje[id];
  }

  onPageChange(event: any) {
    this.currentPage = <Paginar>event;
  }

  exportExcel(): void {
    const EXCEL_EXTENSION = '.xlsx';
    const canjesEnfermeras = this.fullNotificacionesEnfermeras();
    const titulo = [{ campo: "Canjes de Enfermeras ", fecha: new Date().toLocaleDateString() }];
    const fileName = 'canjes-enfermeras';

    import('xlsx').then((XLSX) => {
      const ws = XLSX.utils.json_to_sheet([]);
      XLSX.utils.sheet_add_json(ws, titulo, { origin: "A2", skipHeader: true });
      XLSX.utils.sheet_add_json(ws, canjesEnfermeras, { origin: "A4" });
      /* generate workbook and add the worksheet */
      const wb = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, ws, 'canjes-enfermeras');
      /* save to file */

      XLSX.writeFile(wb, fileName + '_export_' + new Date().getTime() + EXCEL_EXTENSION);
    });
  }
  fullNotificacionesEnfermeras() {
    const saldoEnfermeras = this.canjeEnfermera.map((item) => { return { "Fecha": item.fechaInicio, Enfermera: item.enfermera.nom_enfermera, "Canje": item.redimir, "Estatus": this.getCanje(item.status) } });
    return saldoEnfermeras;
  }
}
